export const BOT_PERSONALITIES = {
  0: 'generic',
  1: 'formal',
  2: 'casual',
  3: 'funny',
};

export const BOT_PROPERTIES = {
  '%botname': {
    description:
      "Name of the Bot (Bot will tell it's name to the user when asked)",
    examples: [
      {
        usage:
          "I'm %botname, a bot by %company. Here to make your day easier in any way I can! 😄",
        value:
          "I'm Haptik bot, a bot by Haptik. Here to make your day easier in any way I can! 😄",
      },
      {
        usage:
          'I am %botname!. \nPick a task you need my help with 👇 \n{taskbox}',
        value:
          'I am Quiz bot!. \nPick a task you need my help with 👇 \n{taskbox}',
      },
    ],
  },
  '%company': {
    description:
      "Name of the Company/Creator (Bot will tell the company's name to the user when asked)",
    examples: [
      {
        usage: 'Thanks. %company will really be proud to hear that. 😄',
        value: 'Thanks. Haptik will really be proud to hear that. 😄',
      },
      {
        usage: 'How sweet. %company loves you too!',
        value: 'How sweet. Haptik loves you too!',
      },
    ],
  },
  '%location': {
    description:
      "Location of the bot/company (Bot will tell it's location to the user when asked)",
    examples: [
      {
        usage:
          "Sorry, I don't share my address with strangers." +
          ' Kidding. I live on a server at %location.😝',
        value:
          "Sorry, I don't share my address with strangers." +
          ' Kidding. I live on a server at Mumbai.😝',
      },
      {
        usage: 'For me, home is where %company is. At %location.😄',
        value: 'For me, home is where Haptik is. At Mumbai.😄',
      },
    ],
  },
  '%appname': {
    description:
      'Name of the app (Bot will tell the app’s name to the user when asked)',
    examples: [
      {
        usage: 'This app is called %appname!',
        value: 'This app is called Haptik!',
      },
      {
        usage: "It's %appname.",
        value: "It's FuturePay.",
      },
    ],
  },
  '%feedbacklink': {
    description:
      'Bot will reply with feedback smart action if no value is provided,' +
      ' Otherwise a link smart action will be created with the value provided',
    examples: [
      {
        usage:
          'You can leave your review by tapping on the link below: %feedbacklink',
        value:
          'You can leave your review by tapping on the link below: {feedback}',
      },
      {
        usage: 'To give me feedback, tap below 👇 %feedbacklink',
        value:
          '{"text":"To give me feedback, tap below 👇 ",' +
          '"type":"BUTTON","data":{"items":[{"actionable_text":"Give Feedback",' +
          '"location_required":false,"is_default":0,"uri":"LINK",' +
          '"type":"APP_ACTION",' +
          '"payload":{"url":"https://example.com/feedback",' +
          '"gogo_message":""}}]},"isNew":false}',
      },
    ],
  },
  '%sitelink': {
    description:
      'Company Website (Bot will send a smart action to the user when asked)',
    examples: [
      {
        usage: 'Sure. You can visit the our website at %sitelink',
        value:
          '{"text":"Sure. You can visit the our website at ",' +
          '"type":"BUTTON","data":{"items":[{"actionable_text":"Click here",' +
          '"location_required":false,"is_default":0,"uri":"LINK",' +
          '"type":"APP_ACTION",' +
          '"payload":{"url":"https://haptik.ai/",' +
          '"gogo_message":""}}]},"isNew":false}',
      },
    ],
  },
  '%botgender': {
    description:
      "Gender of the bot (Bot will tell it's gender to the user when asked)",
    examples: [
      {
        usage: 'Well, I am clearly a %botgender.',
        value: 'Well, I am clearly a bot.',
      },
      {
        usage:
          'My creators were hoping for a %botgender. ' +
          "But it doesn't matter anyway since I'm a bot. 😄",
        value:
          'My creators were hoping for a girl. ' +
          "But it doesn't matter anyway since I'm a bot. 😄",
      },
    ],
  },
};
